import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type Affiliate = {
  address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  metro?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  work_schedule?: Maybe<Scalars['String']['output']>;
};

export type Block = {
  contentAll?: Maybe<Scalars['String']['output']>;
  expressCourse?: Maybe<Array<Maybe<ExpressCourse>>>;
  feedbacks?: Maybe<Array<Maybe<Feedback>>>;
  galleries?: Maybe<Array<Maybe<Gallery>>>;
  id?: Maybe<Scalars['ID']['output']>;
  languageLevels?: Maybe<Array<Maybe<LanguageLevel>>>;
  languages?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trainingCourse?: Maybe<Array<Maybe<TrainingCourse>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Bootstrap = {
  footer?: Maybe<Array<Maybe<Footer>>>;
  settings?: Maybe<Array<Maybe<Setting>>>;
  sidebar?: Maybe<Array<Maybe<Sidebar>>>;
  text_in_site?: Maybe<Array<Maybe<TextInSite>>>;
};

export type CreateRequestInput = {
  affiliates_id?: InputMaybe<Scalars['Int']['input']>;
  full_name: Scalars['String']['input'];
  is_lessons?: InputMaybe<Scalars['Boolean']['input']>;
  landing_id: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  utm_tags?: InputMaybe<Scalars['String']['input']>;
};

export type ExpressCourse = {
  color?: Maybe<SiteColor>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  long_description?: Maybe<Scalars['String']['output']>;
  prerequisite?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  price_of_hour?: Maybe<Scalars['Int']['output']>;
  sticker?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  you_can?: Maybe<Scalars['String']['output']>;
};

export type Faq = {
  answer?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Feedback = {
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  language_level?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Footer = {
  name?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Page>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type Gallery = {
  gallery?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slider?: Maybe<Array<Maybe<Slider>>>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  original?: Maybe<Scalars['String']['output']>;
};

export type Landing = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LanguageLevel = {
  grammar_percent?: Maybe<Scalars['Int']['output']>;
  grammar_skills?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_migration?: Maybe<Scalars['Boolean']['output']>;
  is_tourism?: Maybe<Scalars['Boolean']['output']>;
  is_work?: Maybe<Scalars['Boolean']['output']>;
  language_level_code?: Maybe<Scalars['String']['output']>;
  mastery_percent?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name2?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  topics?: Maybe<Scalars['String']['output']>;
  vocabulary_percent?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  createRequest?: Maybe<RequestWithMessage>;
};


export type MutationCreateRequestArgs = {
  input: CreateRequestInput;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type Page = {
  blocks?: Maybe<Array<Maybe<Block>>>;
  content?: Maybe<Scalars['String']['output']>;
  faqs?: Maybe<Array<Maybe<Faq>>>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image_alt?: Maybe<Scalars['String']['output']>;
  image_title?: Maybe<Scalars['String']['output']>;
  landing?: Maybe<Landing>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Array<Maybe<Setting>>>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PageInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type PaginatorInfo = {
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type Query = {
  affiliates?: Maybe<Array<Maybe<Affiliate>>>;
  languageLevels?: Maybe<Array<Maybe<LanguageLevel>>>;
  page?: Maybe<Page>;
  /** View single Setting. */
  settings?: Maybe<Bootstrap>;
};


export type QueryPageArgs = {
  input: PageInput;
};

export type Request = {
  affiliates_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_lessons?: Maybe<Scalars['Boolean']['output']>;
  landing_id?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type RequestWithMessage = {
  message?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Request>;
};

export type Setting = {
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  to_front?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Sidebar = {
  name?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Page>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type SiteColor = {
  hex_value?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Slider = {
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type TextInSite = {
  key?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TrainingCourse = {
  amount_of_study_hours?: Maybe<Scalars['String']['output']>;
  as_needed?: Maybe<Scalars['String']['output']>;
  base_price?: Maybe<Scalars['String']['output']>;
  count_of_lessons?: Maybe<Scalars['String']['output']>;
  course_details?: Maybe<Scalars['String']['output']>;
  course_duration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_intensive_course?: Maybe<Scalars['Boolean']['output']>;
  knowledge_control?: Maybe<Scalars['String']['output']>;
  lesson_duration?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  price_of_education?: Maybe<Scalars['String']['output']>;
  regularity_of_lessons?: Maybe<Scalars['String']['output']>;
  sale_1?: Maybe<Scalars['String']['output']>;
  sale_2?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  text_button?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type User = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SignUpMutationVariables = Exact<{
  input: CreateRequestInput;
}>;


export type SignUpMutation = { createRequest?: { message?: string | null } | null };

export type HomeQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type HomeQuery = { page?: { content?: string | null, slug?: string | null, meta_title?: string | null, meta_description?: string | null, settings?: Array<{ key?: string | null, name?: string | null, to_front?: boolean | null, value?: string | null } | null> | null, blocks?: Array<{ type?: string | null, name?: string | null, id?: string | null, contentAll?: string | null, expressCourse?: Array<{ description?: string | null, id?: string | null, sticker?: string | null, prerequisite?: string | null, price?: number | null, price_of_hour?: number | null, title?: string | null, you_can?: string | null, long_description?: string | null, color?: { hex_value?: string | null, name?: string | null, id?: string | null } | null } | null> | null, feedbacks?: Array<{ id?: string | null, image?: string | null, name?: string | null, status?: boolean | null, text?: string | null, language_level?: string | null } | null> | null, languageLevels?: Array<{ name?: string | null, id?: string | null, grammar_percent?: number | null, grammar_skills?: string | null, is_migration?: boolean | null, is_tourism?: boolean | null, is_work?: boolean | null, mastery_percent?: number | null, name2?: string | null, language_level_code?: string | null, result?: string | null, status?: boolean | null, topics?: string | null, vocabulary_percent?: number | null } | null> | null, trainingCourse?: Array<{ amount_of_study_hours?: string | null, as_needed?: string | null, count_of_lessons?: string | null, course_details?: string | null, course_duration?: string | null, id?: string | null, title?: string | null, text_button?: string | null, status?: boolean | null, schedule?: string | null, regularity_of_lessons?: string | null, price_of_education?: string | null, lesson_duration?: string | null, knowledge_control?: string | null, is_intensive_course?: boolean | null, sale_1?: string | null, sale_2?: string | null, base_price?: string | null, note?: string | null } | null> | null } | null> | null } | null };

export type LayoutQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type LayoutQuery = { page?: { id?: string | null, slug?: string | null, status?: boolean | null, title?: string | null, landing?: { id: string, url?: string | null, name?: string | null } | null, blocks?: Array<{ name?: string | null, id?: string | null, type?: string | null } | null> | null } | null, settings?: { settings?: Array<{ key?: string | null, name?: string | null, to_front?: boolean | null, value?: string | null } | null> | null, text_in_site?: Array<{ key?: string | null, text?: string | null } | null> | null } | null, affiliates?: Array<{ address?: string | null, id?: string | null, lat?: number | null, lng?: number | null, metro?: string | null, work_schedule?: string | null, image?: string | null, url?: string | null } | null> | null };


export const SignUpDocument = gql`
    mutation SignUp($input: CreateRequestInput!) {
  createRequest(input: $input) {
    message
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const HomeDocument = gql`
    query Home($slug: String!) {
  page(input: {slug: $slug}) {
    content
    settings {
      key
      name
      to_front
      value
    }
    blocks {
      expressCourse {
        description
        id
        sticker
        prerequisite
        price
        price_of_hour
        title
        you_can
        long_description
        color {
          hex_value
          name
          id
        }
      }
      feedbacks {
        id
        image
        name
        status
        text
        language_level
      }
      languageLevels {
        name
        id
        grammar_percent
        grammar_skills
        is_migration
        is_tourism
        is_work
        mastery_percent
        name2
        language_level_code
        result
        status
        topics
        vocabulary_percent
      }
      trainingCourse {
        amount_of_study_hours
        as_needed
        count_of_lessons
        course_details
        course_duration
        id
        title
        text_button
        status
        schedule
        regularity_of_lessons
        price_of_education
        lesson_duration
        knowledge_control
        is_intensive_course
        sale_1
        sale_2
        base_price
        note
      }
      type
      name
      id
      contentAll
    }
    slug
    meta_title
    meta_description
  }
}
    `;

/**
 * __useHomeQuery__
 *
 * To run a query within a React component, call `useHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useHomeQuery(baseOptions: Apollo.QueryHookOptions<HomeQuery, HomeQueryVariables> & ({ variables: HomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
      }
export function useHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
        }
export function useHomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeQuery, HomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
        }
export type HomeQueryHookResult = ReturnType<typeof useHomeQuery>;
export type HomeLazyQueryHookResult = ReturnType<typeof useHomeLazyQuery>;
export type HomeSuspenseQueryHookResult = ReturnType<typeof useHomeSuspenseQuery>;
export type HomeQueryResult = Apollo.QueryResult<HomeQuery, HomeQueryVariables>;
export const LayoutDocument = gql`
    query Layout($slug: String!) {
  page(input: {slug: $slug}) {
    id
    slug
    status
    title
    landing {
      id
      url
      name
    }
    blocks {
      name
      id
      type
    }
  }
  settings {
    settings {
      key
      name
      to_front
      value
    }
    text_in_site {
      key
      text
    }
  }
  affiliates {
    address
    id
    lat
    lng
    metro
    work_schedule
    image
    url
  }
}
    `;

/**
 * __useLayoutQuery__
 *
 * To run a query within a React component, call `useLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useLayoutQuery(baseOptions: Apollo.QueryHookOptions<LayoutQuery, LayoutQueryVariables> & ({ variables: LayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutQuery, LayoutQueryVariables>(LayoutDocument, options);
      }
export function useLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutQuery, LayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutQuery, LayoutQueryVariables>(LayoutDocument, options);
        }
export function useLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LayoutQuery, LayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LayoutQuery, LayoutQueryVariables>(LayoutDocument, options);
        }
export type LayoutQueryHookResult = ReturnType<typeof useLayoutQuery>;
export type LayoutLazyQueryHookResult = ReturnType<typeof useLayoutLazyQuery>;
export type LayoutSuspenseQueryHookResult = ReturnType<typeof useLayoutSuspenseQuery>;
export type LayoutQueryResult = Apollo.QueryResult<LayoutQuery, LayoutQueryVariables>;